import {
  FiKey,
  FiLock,
  FiRotateCw,
  FiSend,
  FiSmartphone,
} from "react-icons/fi";
import Button from "../../components/Button";
import { useCallback, useState } from "react";
import { LockIcon, LogoDarkIcon, RefreshIcon } from "../../assets/icons";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import {
  loginUser,
  requestCaptcha,
  sendCode,
  verifyCode,
} from "../../api/methods/Authentication";
import { useDispatch } from "react-redux";
import { loginInfo, saveToken } from "../../actions";
import { useNavigate } from "react-router-dom";
import { customToast, latinNumber } from "../../utils/General";
import { osName } from "react-device-detect";
import moment from "moment-jalaali";
import { AnimatePresence, motion } from "framer-motion";
import Div100vh from "react-div-100vh";
import Background from "../../assets/icons/loginBackground.jpg";
import { BASE_URL } from "../../api/ApiConstants";
import Tooltip from "../../components/ToolTip";
import FakeCaptcha from "../../assets/icons/fakeCaptcha.png";
import Input from "../../components/Input";
import CustomInput from "../../components/CustomInput";

const packageJson = require("../../../package.json");

const Login = () => {
  const tabs = [
    {
      id: 0,
      label: "ورود با رمز",
      icon: <FiKey size={20} />,
      isWithPass: true,
    },
    {
      id: 1,
      label: "ورود با پیامک",
      icon: <FiSend size={20} />,
      isWithPass: false,
    },
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const SaveToken = (Token) => dispatch(saveToken(Token));
  const LoginInfo = (data) => dispatch(loginInfo(data));
  const {
    register,
    handleSubmit,
    watch,
    setFocus,
    formState: { errors },
  } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [loginWithPassword, setLoginWithPassword] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  const [hasOTPCode, setHasOTPCode] = useState(false);
  const [CaptchaCode, setCaptchaCode] = useState("");
  const [captchaSvg, setCaptchaSvg] = useState("");
  const [CaptchaText, setCaptchaText] = useState("");

  const { isLoading, refetch } = useQuery(["captcha"], () => requestCaptcha(), {
    onSuccess: (response) => {
      const buff = new Buffer(response?.data?.data?.captcha);
      const base64data = buff.toString("base64");
      setCaptchaSvg(base64data);
      setCaptchaCode(response?.data?.data?.code);
    },
  });

  const verifyOTPCode = useMutation(["verifyOTPCode"], {
    mutationFn: verifyCode,
    onSettled: (response) => {
      if (response.data.success) {
        let Token, data;
        if (response.data.data.result) {
          Token = response.data.data.result.Token;
          delete response.data.data.result.Token;
          data = response.data.data.result;
        }
        if (Token && data?.Level >= 2) {
          localStorage.setItem("Token", Token);
          SaveToken(Token);
          LoginInfo(data);
          navigate("/");
        } else {
          customToast("error", "کد وارد شده اشتباه است");
          refetch();
          setCaptchaText("");
        }
      } else {
        customToast("error", "کد وارد شده اشتباه است");
        refetch();
        setCaptchaText("");
      }
    },
  });
  const inputs = watch();
  const sendOTPCode = useMutation(["sendCode"], {
    mutationFn: sendCode,
    onSettled: (response) => {
      if (response?.data?.success) {
        customToast("success", "کد تایید به شماره وارد شده ارسال گردید.");
        setHasOTPCode(true);
      } else {
        if (response?.data?.code === -30) {
          const diff =
            moment().diff(response.data.data.Next, "minutes") === 0
              ? moment().diff(response.data.data.Next, "seconds")
              : moment().diff(response.data.data.Next, "minutes");
          const msg = ` لطفا برای استفاده مجدد ${-diff} ${
            moment().diff(response.data.data.Next, "minutes") === 0
              ? "ثانیه"
              : "دقیقه"
          } صبر کنید `;
          customToast("error", msg);
          refetch();
        } else {
          customToast("error", response?.data?.message?.pr);
          refetch();
          setCaptchaText("");
        }
      }
    },
  });
  const passwordLogin = useMutation(["passwordLogin"], {
    mutationFn: loginUser,
    onSettled: (response) => {
      if (response?.data?.success) {
        let Token, data;
        if (response?.data?.data?.result) {
          Token = response?.data.data.result.Token;
          delete response?.data.data.result.Token;
          data = response?.data.data.result;
        }
        if (Token && data?.Level >= 2) {
          localStorage.setItem("Token", Token);
          SaveToken(Token);
          LoginInfo(data);
          navigate("/");
        } else {
          customToast("error", "نام کاربری یا کلمه عبور اشتباه است");
          refetch();
          setCaptchaText("");
        }
      } else {
        customToast("error", response?.data?.message?.pr);
        refetch();
        setCaptchaText("");
      }
    },
  });
  const onToggleShowPassword = useCallback(
    (event) => {
      setShowPassword(event === "down");
    },
    [setShowPassword]
  );

  const loginWithPasswordSubmit = async (data) => {
    await passwordLogin.mutateAsync({
      data: {
        Username: data.mobile,
        Password: data.password,
        DeviceName: osName,
        CaptchaCode,
        CaptchaText,
      },
    });
  };

  const loginWithOTPSubmit = async (data) => {
    if (hasOTPCode) {
      await verifyOTPCode.mutateAsync({
        data: {
          MobileNumber: data["mobile"],
          VerificationCode: data.otp,
          DeviceName: osName,
        },
      });
    } else {
      await sendOTPCode.mutateAsync({
        data: {
          MobileNumber: data["mobile"],
          CaptchaCode,
          CaptchaText,
        },
      });
    }
  };
  return (
    <Div100vh>
      <div className="fixed top-0 z-50 py-2 px-4 w-full h-fit bg-attention">
        <p className="font-normal text-center">
          شما در حال استفاده از نسخه جدید پنل مدیریت سهامداران هستید. در صورت
          نیاز به استفاده از نسخه قدیمی میتوانید از{" "}
          <a
            className="font-semibold hover:opacity-70 text-[#fff]"
            href={
              BASE_URL.includes("https://st2api.hbbs.ir/") ||
              BASE_URL.includes("http://api.test.hamrahbours.ir/") ||
              BASE_URL.includes("http://apitest.hamrahbours.ir/")
                ? "https://stoldcp.hbbs.ir/"
                : "https://oldcp.hbbs.ir/"
            }
          >
            این لینک
          </a>{" "}
          استفاده نمایید.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 h-full min-w-full relative">
        <div
          className="absolute inset-0"
          style={{
            background: `url(${Background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            filter: "brightness(0.35) blur(2px)",
            transform: "scale(1.2)",
            zIndex: -1,
          }}
        />
        <div className="flex flex-col justify-center items-center h-full min-w-full relative">
          <div className="min-h-[50vh] w-full sm:border-l-2 border-gray-400 sm:min-h-[60vh] grid grid-cols-1 py-4 px-4 sm:px-12">
            <div className="flex flex-col items-center gap-y-4 pt-4 overflow-hidden">
              <div className="flex items-center w-full gap-x-3 justify-center self-start">
                <h1 className="font-semibold text-center sm:text-4xl sm:mb-12 text-gray-50">
                  پنل مدیریت درخواست سهامداران
                </h1>
              </div>

              <div className="grid pb-0.5 grid-cols-2 gap-x-6 mb-4 z-10 relative">
                {tabs.map((tab) => (
                  <div
                    key={tab.id}
                    onClick={() => {
                      setFocus("mobile");
                      setSelectedTab(tab.id);
                      setLoginWithPassword(tab.isWithPass);
                      setCaptchaText("");
                      refetch();
                    }}
                    className={`${
                      selectedTab === tab.id
                        ? "text-[#fff] font-bold"
                        : "text-[#fff] opacity-60 hover:opacity-70 font-medium"
                    } relative px-3 py-2 cursor-pointer flex items-center justify-center gap-x-2 text-xs lg:text-sm`}
                  >
                    {selectedTab === tab.id && (
                      <motion.span
                        layoutId="bubble"
                        className="absolute rounded-lg -bottom-2 w-full h-1 -z-10 bg-[#fff]"
                        transition={{
                          duration: 0.5,
                        }}
                      />
                    )}
                    {tab.icon}
                    <span className="relative whitespace-nowrap">
                      {tab.label}
                    </span>
                  </div>
                ))}
              </div>
              {loginWithPassword ? (
                <AnimatePresence exitBeforeEnter>
                  <motion.form
                    key={0}
                    initial={{
                      opacity: 0,
                      x: "100%",
                    }}
                    animate={{
                      opacity: "100%",
                      x: "0",
                    }}
                    exit={{
                      opacity: 0,
                      x: "100%",
                    }}
                    transition={{
                      duration: 0.25,
                    }}
                    onSubmit={handleSubmit(loginWithPasswordSubmit)}
                    autoComplete="off"
                    className="flex flex-col w-3/4 sm:w-1/2 mx-auto h-full justify-between gap-y-8 mt-4 min-h-[293px]"
                  >
                    <Input
                      isLoginInput
                      register={register}
                      name="mobile"
                      options={{
                        required: true,
                        onChange: (e) => {
                          e.target.value = latinNumber(e.target.value.trim());
                          if (e.target.value.length === 11) {
                            setFocus("password");
                          }
                        },
                        minLength: 11,
                        maxLength: 11,
                        pattern: /^[0-9]*$/g,
                      }}
                      type="tel"
                      maxLength={11}
                      autoFocus
                      textAlign="left"
                      label="شماره همراه"
                      placeholder="مثلا 09129999999"
                      leftIcon={<FiSmartphone color="#fff" size={20} />}
                      hasError={errors.mobile}
                      msg="لطفا شماره موبایل را به صورت صحیح وارد نمایید"
                      readOnly={passwordLogin.isLoading}
                    />
                    <Input
                      type={showPassword ? "text" : "password"}
                      register={register}
                      name="password"
                      options={{
                        required: true,
                        onChange: (e) => {
                          e.target.value = latinNumber(e.target.value.trim());
                        },
                      }}
                      textAlign="left"
                      onShowPasswordToggle={onToggleShowPassword}
                      autoComplete="off"
                      forceShowPasswordToggle
                      leftIcon={<LockIcon />}
                      label="رمز عبور"
                      hasError={errors.password}
                      msg="لطفا رمز عبور خود را وارد نمایید"
                      isLoginInput
                      readOnly={passwordLogin.isLoading}
                    />
                    <CustomInput
                      isLoginInput
                      leftIcon={
                        <Tooltip content="کد جدید">
                          <div>
                            <RefreshIcon
                              className="cursor-pointer transition-all duration-200 hover:rotate-180 hover:opacity-70 fill-[#fff]"
                              onClick={() => {
                                setCaptchaText("");
                                refetch();
                              }}
                            />
                          </div>
                        </Tooltip>
                      }
                      captcha={
                        isLoading
                          ? FakeCaptcha
                          : `data:image/svg+xml;base64,${captchaSvg}`
                      }
                      textAlign={"left"}
                      autoComplete={"off"}
                      disabled={isLoading}
                      value={CaptchaText}
                      name={"captcha"}
                      maxLength={4}
                      onChange={(event) => {
                        setCaptchaText(event.target.value);
                      }}
                      className={"min-w-full"}
                      label="کد امنیتی"
                    />
                    <Button
                      darkStyle
                      as="button"
                      loading={passwordLogin.isLoading}
                      disabled={
                        passwordLogin.isLoading || CaptchaText.length !== 4
                      }
                      type="submit"
                      className="mt-auto w-full mx-auto"
                    >
                      ورود
                    </Button>
                  </motion.form>
                </AnimatePresence>
              ) : (
                <AnimatePresence exitBeforeEnter>
                  <motion.form
                    key={1}
                    initial={{
                      opacity: 0,
                      x: "100%",
                    }}
                    animate={{
                      opacity: "100%",
                      x: "0",
                    }}
                    exit={{
                      opacity: 0,
                      x: "100%",
                    }}
                    transition={{
                      duration: 0.25,
                    }}
                    onSubmit={handleSubmit(loginWithOTPSubmit)}
                    autoComplete="off"
                    className="flex flex-col w-3/4 sm:w-1/2 mx-auto h-full justify-between gap-y-8 mt-4 min-h-[293px]"
                  >
                    <Input
                      isLoginInput
                      register={register}
                      name="mobile"
                      options={{
                        required: true,
                        minLength: 11,
                        maxLength: 11,
                        pattern: /^[0-9]*$/g,
                        onChange: (e) => {
                          e.target.value = latinNumber(e.target.value.trim());
                        },
                      }}
                      type="tel"
                      maxLength={11}
                      autoFocus
                      className="mb-4"
                      textAlign="left"
                      label="شماره همراه"
                      placeholder="مثلا 09129999999"
                      leftIcon={<FiSmartphone color="#fff" size={20} />}
                      hasError={errors.mobile}
                      msg="لطفا شماره موبایل را به صورت صحیح وارد نمایید"
                      readOnly={sendOTPCode.isLoading || hasOTPCode}
                      disabled={sendOTPCode.isLoading || hasOTPCode}
                    />
                    <CustomInput
                      isLoginInput
                      leftIcon={
                        <Tooltip content="کد جدید">
                          <div>
                            <RefreshIcon
                              className="cursor-pointer transition-all duration-200 hover:rotate-180 hover:opacity-70 fill-[#fff]"
                              onClick={() => {
                                setCaptchaText("");
                                refetch();
                              }}
                            />
                          </div>
                        </Tooltip>
                      }
                      captcha={
                        isLoading
                          ? FakeCaptcha
                          : `data:image/svg+xml;base64,${captchaSvg}`
                      }
                      textAlign={"left"}
                      autoComplete={"off"}
                      disabled={isLoading || hasOTPCode}
                      value={CaptchaText}
                      name={"captcha"}
                      maxLength={4}
                      onChange={(event) => {
                        setCaptchaText(event.target.value);
                      }}
                      className={"min-w-full"}
                      label="کد امنیتی"
                    />
                    {hasOTPCode && (
                      <Input
                        isLoginInput
                        spacing
                        type={showPassword ? "text" : "password"}
                        register={register}
                        name="otp"
                        maxLength={5}
                        options={{
                          required: true,
                          maxLength: 5,
                          onChange: (e) => {
                            e.target.value = latinNumber(e.target.value.trim());
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                          },
                        }}
                        textAlign="center"
                        onShowPasswordToggle={onToggleShowPassword}
                        autoComplete="off"
                        forceShowPasswordToggle
                        autoFocus
                        leftIcon={<FiLock color="#fff" size={20} />}
                        className="mb-4"
                        label="کد ارسال شده"
                        hasError={errors.otp}
                        msg="لطفا کد ارسال شده را وارد نمایید"
                        readOnly={sendOTPCode.isLoading}
                      />
                    )}

                    {hasOTPCode && (
                      <Button
                        darkStyle
                        disabled={sendOTPCode.isLoading}
                        rightIcon={
                          <FiRotateCw
                            size={18}
                            className="ml-1"
                            color="white"
                          />
                        }
                        onClick={() => {
                          sendOTPCode.mutateAsync({
                            data: {
                              MobileNumber: inputs?.mobile,
                            },
                          });
                        }}
                        className="w-full mx-auto mt-auto"
                        variant="hidden"
                      >
                        <span className="text-[#fff]">
                          ارسال مجدد رمز یک بار مصرف
                        </span>
                      </Button>
                    )}

                    <Button
                      darkStyle
                      as="button"
                      loading={
                        sendOTPCode.isLoading ||
                        passwordLogin.isLoading ||
                        verifyOTPCode.isLoading
                      }
                      disabled={
                        sendOTPCode.isLoading ||
                        passwordLogin.isLoading ||
                        verifyOTPCode.isLoading ||
                        CaptchaText.length !== 4
                      }
                      type="submit"
                      className="w-full mx-auto mt-auto"
                    >
                      {!loginWithPassword && !hasOTPCode ? "ارسال کد" : "ورود"}
                    </Button>
                  </motion.form>
                </AnimatePresence>
              )}
            </div>
          </div>
        </div>
        <div className="hidden flex-col items-center justify-center h-full w-full sm:flex">
          <LogoDarkIcon className="scale-150" />
          <motion.div
            className="z-40"
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{
              duration: 2,
            }}
            exit={{
              opacity: 0,
            }}
          >
            <p className="text-sm text-white font-medium dark:text-title text-center pb-1 mt-8 z-40">
              توسعه و طراحی توسط{" "}
              <a
                className="m-1 text-sky-300"
                target="_blank"
                rel="noreferrer"
                href="http://inotek.ir/"
              >
                شرکت مبتکر فناوری پایور
              </a>
            </p>
            <p className="text-center text-white dark:text-title relative py-1 text-sm">
              نسخه
              <span className="mr-1">{packageJson.version}</span>
            </p>
          </motion.div>
        </div>
      </div>
    </Div100vh>
  );
};

export default Login;
